/* Effetti delle valvole: aria che entra (aspirazione) e fumo che esce (scarico) */

.valve-fx {
  position: absolute;
  left: 50%;
  pointer-events: none;
  transform: translateX(-50%);
}

/* ---------- Aria in entrata ---------- */
.valve-air {
  top: -18px;
  width: 64px;
  height: 100px;
}

.air-streak {
  position: absolute;
  top: 0;
  width: 3px;
  height: 26px;
  border-radius: 3px;
  background: linear-gradient(to bottom, transparent, #7dd3fc 70%, #e0f2fe);
  box-shadow: 0 0 6px rgba(125, 211, 252, 0.8);
  opacity: 0;
  animation: air-flow 0.85s linear infinite;
}

.air-glow {
  position: absolute;
  left: 50%;
  top: 58px;
  width: 80px;
  height: 56px;
  transform: translateX(-50%);
  border-radius: 50%;
  background: radial-gradient(ellipse, rgba(56, 189, 248, 0.5), transparent 70%);
  filter: blur(3px);
  animation: air-glow 0.85s ease-in-out infinite;
}

@keyframes air-flow {
  0%   { transform: translate(0, -4px) scaleY(0.6); opacity: 0; }
  20%  { opacity: 1; }
  100% { transform: translate(var(--dx, 0), 82px) scaleY(1.2); opacity: 0; }
}

@keyframes air-glow {
  0%, 100% { opacity: 0.35; }
  50%      { opacity: 1; }
}

/* ---------- Fumo in uscita ---------- */
.valve-smoke {
  top: 18px;
  width: 44px;
  height: 10px;
}

.smoke-puff {
  position: absolute;
  left: 50%;
  top: 0;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(226, 232, 240, 0.9), rgba(148, 163, 184, 0.55) 55%, transparent 75%);
  filter: blur(2.5px);
  opacity: 0;
  animation: smoke-rise 1.7s ease-out infinite;
}

@keyframes smoke-rise {
  0%   { transform: translate(0, 0) scale(0.4); opacity: 0; }
  15%  { opacity: 0.9; }
  100% { transform: translate(var(--dx, 0), -90px) scale(2.2); opacity: 0; }
}

/* ---------- Iniettore ---------- */
.injector-glow {
  transition: opacity 80ms ease-out;
}

@media (prefers-reduced-motion: reduce) {
  .air-streak,
  .air-glow,
  .smoke-puff {
    animation: none;
    opacity: 0.6;
  }
}
